import script from "./UpdateDialog-IPROXY.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateDialog-IPROXY.vue?vue&type=script&setup=true&lang=js"

import "./UpdateDialog-IPROXY.vue?vue&type=style&index=0&id=4b1282b9&scoped=true&lang=css"

import exportComponent from "../../../../../../../../var/local/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b1282b9"]])

export default __exports__